import {
  Col,
  Divider,
  Form,
  Grid,
  Input,
  Row,
  Select,
  Statistic,
  Tabs,
  Typography,
} from 'antd';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { countryCode } from 'src/shared/assets/data/countryCode';
import loginImg from 'src/shared/assets/images/login.png';
import backSvg from 'src/shared/assets/svg/icon/back.svg';
import siblSvg from 'src/shared/assets/svg/icon/sibl.svg';
import supportSvg from 'src/shared/assets/svg/icon/support.svg';
import {
  ButtonC,
  FlagC,
  FormC,
  FormItemC,
  InputC,
  VerificationInputC,
} from 'src/shared/components';
import validationEmail from 'src/shared/function/validationEmail';
import validateIranianPhoneNumber from 'src/shared/function/validationIranianPhoneNumber';
import useAuth from 'src/shared/hooks/useAuth';
import useDirection from 'src/shared/hooks/useDirection';
import useDomain from 'src/shared/hooks/useDomain';
import useRequest from 'src/shared/hooks/useRequest';
import { AuthContext } from 'src/shared/provider/auth.provider';
import useSWR from 'swr';
import './index.less';

const Login = () => {
  const domainData = useDomain();
  const [form] = Form.useForm();
  const {} = useAuth();
  const { authState, setAuth, setIsLogedIn, isLogedIn } =
    useContext(AuthContext);
  const { useBreakpoint } = Grid;
  const { lg, md, sm, xl, xs, xxl } = useBreakpoint();
  const { styler } = useDirection();
  const { t, i18n } = useTranslation();
  const { data: languages } = useSWR(`/localization/languages`);

  // Flags;
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // localStorage.setItem("lng", lng);
  };
  const { onCreate, loading, onGet, onEdit } = useRequest();
  const [isLoginEmail, setIsLoginEmail] = useState(false);
  const [stepState, setStepState] = useState<
    'login' | 'login with email' | 'login with mobile' | 'forget password'
  >('login');
  const [finishResendTime, setFinishResendTime] = useState(false);
  const [inputState, setInputState] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [tokenCode, setTokenCode] = useState<string>();

  const loginStepSwitcher = () => {
    switch (stepState) {
      case 'login':
        return (
          <>
            <Col xs={24} lg={22} style={{ textAlign: 'center' }}>
              <Row justify='center'>
                <Col span={24} style={{ textAlign: 'center' }}>
                  <Typography.Text strong className='title_under_divider'>
                    {t('login')}/{t('register')}
                  </Typography.Text>
                </Col>

                <Col span={24}>
                  <Divider />
                </Col>

                <Col span={24} style={{ textAlign: 'center' }}>
                  <Tabs
                    centered
                    defaultActiveKey='2'
                    animated
                    style={{
                      // boxShadow:"2px 2px 10px 0px rgba(0,0,0,.2)",
                      textAlign: 'center',
                      padding: '5px',
                      borderRadius: '15px',
                    }}
                    type='line'
                  >
                    <Tabs.TabPane tab='با ایمیل' key='1'>
                      <Row justify='center'>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <Row gutter={[10, 0]} justify='space-between'>
                            <InputC
                              className='login-phone'
                              formItem={{
                                label: 'ایمیل',
                                name: 'input',
                                rules: [
                                  { required: true },
                                  // { len: 10 },
                                  {
                                    validator: (_, value) => {
                                      if (
                                        /^\d{9,16}$/.test(value) ||
                                        validationEmail(value)
                                      ) {
                                        return Promise.resolve();
                                      } else {
                                        return Promise.reject(
                                          t('invalid contact or email number')
                                        );
                                      }
                                    },
                                  },
                                ],
                              }}
                              placeholder={t('info@*******.com')}
                              col={{ xs: 14, lg: 24 }}
                            />
                          </Row>
                        </Col>
                      </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab='با موبایل' key='2'>
                      <Row justify='center'>
                        <Col span={24} style={{ textAlign: 'center' }}>
                          <Row gutter={[10, 0]} justify='space-between'>
                            <InputC
                              className='login-phone'
                              formItem={{
                                label: 'موبایل',
                                name: 'input',
                                rules: [
                                  { required: true },
                                  // { len: 10 },
                                  {
                                    validator: (_, value) => {
                                      if (
                                        /^\d{9,16}$/.test(value) ||
                                        validationEmail(value)
                                      ) {
                                        return Promise.resolve();
                                      } else {
                                        return Promise.reject(
                                          t('invalid contact or email number')
                                        );
                                      }
                                    },
                                  },
                                ],
                              }}
                              placeholder={t('91********')}
                              col={{ xs: 14, lg: 16 }}
                            />
                            <Col xs={10} lg={8}>
                              <FormItemC
                                name='countryCode'
                                label='کد کشور'
                                initialValue={'+98'}
                              >
                                <Select
                                  dropdownMatchSelectWidth={false}
                                  placement='bottomLeft'
                                  optionLabelProp='label'
                                  // defaultValue={"+98"}
                                  optionFilterProp='children'
                                  filterOption={(input, option: any) =>
                                    String(option.props.children)
                                      .toLowerCase()
                                      .indexOf(String(input).toLowerCase()) >=
                                      0 ||
                                    String(option.props.value)
                                      .toLowerCase()
                                      .indexOf(String(input).toLowerCase()) >= 0
                                  }
                                  showSearch
                                >
                                  {countryCode?.map((i, index) => (
                                    <Select.Option
                                      value={i.dial_code}
                                      key={i.name}
                                      label={
                                        <div
                                          style={{
                                            textAlign: 'center',
                                            direction: 'ltr',
                                          }}
                                        >
                                          <FlagC
                                            key={i.name + index}
                                            style={{ verticalAlign: '-5px' }}
                                            type={i.code}
                                          />
                                          <span> {i.dial_code}</span>{' '}
                                        </div>
                                      }
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                        }}
                                      >
                                        <div
                                          style={{
                                            direction: 'ltr',
                                            fontFamily: 'sans-serif',
                                          }}
                                        >
                                          {i.dial_code}
                                        </div>
                                        <div>{i.name.substring(0, 30)}</div>
                                        <div>
                                          <FlagC
                                            key={i.name}
                                            style={{ verticalAlign: '-5px' }}
                                            type={i.code}
                                          />
                                        </div>
                                      </div>
                                    </Select.Option>
                                  ))}
                                </Select>
                              </FormItemC>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Tabs.TabPane>
                  </Tabs>
                </Col>

                <ButtonC
                  htmlType='submit'
                  block
                  style={{ marginTop: '40px' }}
                  loading={loading}
                >
                  {t('continue')}
                </ButtonC>
                <div
                  style={{
                    marginTop: '20px',
                    ...styler({ textAlign: 'right' }),
                  }}
                  className='terms_and_conditions'
                >
                  {`با ثبت نام در ${domainData.name}`}،{' '}
                  <Typography.Link>{t('terms and conditions')}</Typography.Link>{' '}
                  {`استفاده از سرویس های ${domainData.name}`} {t('and')}{' '}
                  <Typography.Link>{t('privacy laws')}</Typography.Link>{' '}
                  {t('accept it')}.
                </div>
              </Row>
            </Col>
          </>
        );
        break;

      case 'login with mobile':
        return (
          <>
            <Col span={2} />
            <Col span={2}>
              <img
                src={backSvg}
                onClick={() => setStepState('login')}
                style={{ cursor: 'pointer' }}
              />
            </Col>
            <Col span={17}>
              <Row gutter={[0, 20]}>
                <Col span={24}>
                  <Typography.Text strong className='title_under_divider'>
                    {t('login to account')}
                  </Typography.Text>
                </Col>
                <Col span={24}>
                  {t('enter the SMS code to your number')}.
                  <span style={{ direction: 'ltr' }}>({inputState})</span>
                </Col>
                <Col
                  span={24}
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <VerificationInputC
                    onComplete={(e: string) => {
                      setPassword(e);
                      form.submit();
                    }}
                  />
                </Col>
                <Typography.Link
                  style={{ marginTop: '40px' }}
                  onClick={() => setStepState('login')}
                >
                  {t('login with password')}
                </Typography.Link>
                <ButtonC htmlType='submit' block loading={loading}>
                  {t('login')}
                </ButtonC>
                <Col span={24} style={{ textAlign: 'center' }}>
                  {finishResendTime ? (
                    <ButtonC
                      type='default'
                      block
                      onClick={() => {
                        onCreate(
                          `/auth/login-register`,
                          {
                            emailOrMobile: inputState,
                          },
                          { notif: false }
                        );
                      }}
                    >
                      ارسال مجدد
                    </ButtonC>
                  ) : (
                    <Statistic.Countdown
                      title={t('resend the code')}
                      value={Date.now() + 60 * 1000 * 1}
                      onFinish={() => setFinishResendTime(true)}
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </>
        );

      case 'login with email':
        return (
          <>
            <Col span={2} />
            <Col span={2}>
              <img
                src={backSvg}
                onClick={() => setStepState('login')}
                style={{ cursor: 'pointer' }}
              />
            </Col>
            <Col span={17}>
              <Row gutter={[0, 20]}>
                <Col span={24}>
                  <Typography.Text strong className='title_under_divider'>
                    {t('login to account')}
                  </Typography.Text>
                </Col>
                <Col span={24}>{t('enter your password')}.</Col>

                <Col span={24}>
                  <FormItemC
                    label={t('password')}
                    name='password'
                    rules={[{ required: true }]}
                  >
                    <Input.Password placeholder={t('enter your password')} />
                  </FormItemC>
                </Col>
                {!isLoginEmail ? (
                  <>
                    <Col span={24}>
                      <FormItemC
                        label={t('confirm-password')}
                        name='confirm-password'
                        rules={[
                          {
                            required: true,
                            message: 'Please confirm your password!',
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue('password') === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  t(
                                    'The two passwords that you entered do not match!'
                                  )
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          placeholder={t('enter your password')}
                        />
                      </FormItemC>
                    </Col>
                    <Col span={24}>
                      <FormItemC
                        label={t('confirmation Code')}
                        name='confirmationCode'
                        rules={[{ required: true }]}
                      >
                        <Input
                          placeholder={t('enter your confirmation Code')}
                        />
                      </FormItemC>
                    </Col>
                  </>
                ) : null}
                <Typography.Link
                  style={{ marginTop: '40px' }}
                  onClick={() =>
                    onGet(`/auth/forgetPassword/${inputState}`).then(() =>
                      setStepState('forget password')
                    )
                  }
                >
                  {t('forget password')}
                </Typography.Link>
                <ButtonC htmlType='submit' block loading={loading}>
                  {t('login')}
                </ButtonC>
              </Row>
            </Col>
          </>
        );

      case 'forget password':
        return (
          <>
            <Col span={2} />
            <Col span={2}>
              <img
                src={backSvg}
                onClick={() => setStepState('login')}
                style={{ cursor: 'pointer' }}
              />
            </Col>
            <Col span={17}>
              <Row gutter={[0, 5]}>
                <Col span={24}>
                  <Typography.Text strong className='title_under_divider'>
                    {t('forget password')}
                  </Typography.Text>
                </Col>
                <Col span={24}>
                  <FormItemC
                    label={t('new password')}
                    name='password'
                    rules={[{ required: true }, { min: 6, max: 30 }]}
                  >
                    <Input.Password placeholder={t('enter your password')} />
                  </FormItemC>
                </Col>
                <Col span={24}>
                  <FormItemC
                    label={t('confirm new password')}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              t(
                                'The two passwords that you entered do not match!'
                              )
                            )
                          );
                        },
                      }),
                    ]}
                    dependencies={['password']}
                    name='confirm'
                  >
                    <Input.Password placeholder={t('enter your password')} />
                  </FormItemC>
                </Col>
                <Col span={24}>{t('enter the SMS code to your number')}.</Col>
                <Col
                  span={24}
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <VerificationInputC
                    onComplete={(e: string) => {
                      setTokenCode(e);
                    }}
                  />
                </Col>

                <ButtonC
                  style={{ marginTop: '20px' }}
                  htmlType='submit'
                  block
                  loading={loading}
                  disabled={tokenCode?.length != 6}
                >
                  {t('change password')}
                </ButtonC>
                <Col span={24} style={{ textAlign: 'center' }}>
                  <Statistic.Countdown
                    title={t('resend the code')}
                    value={Date.now() + 60 * 1000 * 1}
                    onFinish={() => setFinishResendTime(true)}
                  />
                  {finishResendTime && (
                    <ButtonC
                      type='default'
                      block
                      onClick={() => onCreate(`/auth/sendSms/${inputState}`)}
                    >
                      {t('resend')}
                    </ButtonC>
                  )}
                </Col>
              </Row>
            </Col>
          </>
        );
      default:
        return <></>;
        break;
    }
  };
  const onFinish = (e: any) => {
    const { input, countryCode } = e;
    // const isEmail = input
    //   ? input.split("@").length >= 2
    //   : inputState && inputState.split("@").length >= 2;
    const isEmail = input?.split('@').length >= 2 ? true : false;
    console.log('isEmail', e);
    switch (stepState) {
      case 'login':
        let emailOrMobile;
        if (isEmail) {
          emailOrMobile = input;
        } else {
          emailOrMobile = countryCode + String(Number(input));
        }
        setInputState(emailOrMobile);

        onCreate(
          `/auth/login-register`,
          { emailOrMobile },
          { notif: false }
        ).then((res) => {
          if (isEmail) {
            setStepState('login with email');
            setIsLoginEmail(res?.data?.isRegister);
          } else {
            setStepState('login with mobile');
            // alert(`your token : ${res.data.token}`);
          }
        });
        break;

      case 'login with email': {
        const body = {
          email: inputState,
          password: e.password,
          confirmationCode: e?.confirmationCode,
        };
        return onCreate(`/auth/signin`, body, { notif: false }).then((res) =>
          setAuth(res.data)
        );
        break;
      }

      case 'login with mobile':
        const body = {
          mobile: inputState,
          confirmationCode: password,
        };
        return onCreate(`/auth/signin`, body, { notif: false }).then((res) =>
          setAuth(res.data)
        );
        break;

      case 'forget password':
        return onEdit(
          `/auth/changePassword/${inputState}`,
          {
            token: tokenCode,
            password: e.password,
          },
          { notif: false }
        ).then((res) => setAuth(res.data));
    }
  };
  return (
    <div className='login'>
      <FormC form={form} onFinish={onFinish}>
        <Row gutter={[0, 10]} justify='center'>
          <Col
            md={16}
            lg={12}
            style={{ height: '100vh', overflowY: 'auto', textAlign: 'center' }}
          >
            <Row justify='center' align='middle' style={{ height: '100%' }}>
              <Col xs={20} md={18} lg={14} style={{ textAlign: 'center' }}>
                <Row>
                  <Col span={2} style={{ textAlign: 'center' }}>
                    <img src={siblSvg} />
                  </Col>
                  <Col span={20} style={{ textAlign: 'center' }}>
                    <Typography.Title
                      level={5}
                      style={{
                        ...styler({ marginRight: '5px' }),
                      }}
                    >
                      {domainData?.name}
                    </Typography.Title>
                    <Typography.Text>{domainData?.slogan}</Typography.Text>
                  </Col>
                </Row>
                <Divider />

                <Row justify='center'>
                  {loginStepSwitcher()}
                  <Divider />
                  <Col span={24} style={{ textAlign: 'center' }}>
                    <Row justify='space-between'>
                      <Col xs={24} md={12}>
                        <img src={supportSvg} /> {t('support')}:{' '}
                        {domainData?.supportPhone?.map((item: string) => (
                          <div>{item}</div>
                        ))}
                      </Col>
                      <Col
                        xs={24}
                        md={12}
                        style={{ ...styler({ textAlign: 'left' }) }}
                      >
                        <Select
                          size='small'
                          style={{ width: '120px' }}
                          bordered={false}
                          onChange={changeLanguage}
                          // defaultValue={localStorage.getItem("lng") as string}
                          // @ts-ignore
                          defaultValue={
                            JSON.parse(
                              localStorage.getItem('localization') || '{}'
                            )?.languageKey as string
                          }
                        >
                          {(languages || [])?.map((item: any) => (
                            <Select.Option
                              value={item.language}
                              key={item.language}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                }}
                              >
                                <div>
                                  <FlagC
                                    style={{ verticalAlign: '-5px' }}
                                    type={
                                      item.language.split('-')[
                                        item.language.split('-').length - 1
                                      ]
                                    }
                                  />
                                </div>
                                <div>{item.language}</div>
                              </div>
                            </Select.Option>
                          ))}
                        </Select>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col md={8} lg={12} style={{ width: '100%', height: '100vh' }}>
            <img className='loginImg' src={loginImg} />
          </Col>
        </Row>
      </FormC>
    </div>
  );
};

export default Login;
